import baseStyles from '../Base/Base.styles';
import merge from 'lodash/merge';
export default (props) => {
  const {
    base,
    height,
    backgroundColor,
    barColor,
    titleColor,
    percentage = {},
  } = props;

  let jss = {
    root: {
      ...baseStyles(base, {responsiveAlignment: false}),
      '--background-color': backgroundColor,
      '--bar-color': barColor,
      '--percentage': ((p) => p.value + p.unit)(percentage),
      '--title-color': titleColor,
    },
  };

  return jss;
};
